const useComputePosition = () => {
  const doComputePosition = (props) => {
    const { placement, offsetX, offsetY, container, hoveredElem } = props;

    const { offsetWidth: maxWidth } = document.body;
    const { innerHeight: maxHeight } = window;
    const { width: containerWidth, height: containerHeight } =
      container.getBoundingClientRect();
    const rect = hoveredElem.getBoundingClientRect();
    const { left, top, height, bottom } = rect;

    let placementConfig = {};
    // speed: VERY IMPORTANT to use transform translate instead of right/left/top/bottom
    // https://www.paulirish.com/2012/why-moving-elements-with-translate-is-better-than-posabs-topleft/
    // https://web.dev/animations-guide/#move
    if (placement === 'middle') {
      placementConfig.left = `${maxWidth / 2 - containerWidth / 2}px`;
    } else if (left + offsetX + containerWidth > maxWidth) {
      //flip it - no space available on X
      placementConfig.right = 0;
      placementConfig.left = 'auto';
    } else {
      placementConfig.left = `${left + offsetX}px`;
    }
    const spaceAvailableBeneath = top + height + containerHeight;
    const hasSpaceAvailableBeneath = spaceAvailableBeneath <= maxHeight;

    if (hasSpaceAvailableBeneath && placement === 'bottom') {
      //position beneath the hovered element
      placementConfig.top = `${window.scrollY + top + height + offsetY}px`;
      placementConfig.bottom = 'auto';
    } else {
      //position above the hovered element
      placementConfig.top = 'auto';
      placementConfig.bottom = `${
        maxHeight - window.scrollY - bottom + height + offsetY
      }px`;
    }

    Object.assign(container.style, {
      ...placementConfig,
    });
  };

  return { doComputePosition };
};

useComputePosition.propTypes = {};

export default useComputePosition;
